<template>
  <section class="section" :class="{ '--has-padding': hasPadding }">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'Section',
  props: {
    hasPadding: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Section
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present page's section wrapper styles
 * @since 2021-04-13
**/

$component: 'section';

.#{$component} {
  width: 100%;

  &.--has-padding {
    @include padding-top(map-get($spacers, 4) * 4);
    @include padding-bottom(map-get($spacers, 4) * 4);
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
